import { graphql } from '@/gql';
import type { OperatorOptionsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

// Name-only lookup for pickers: the full Operators query also returns contact details and Slack webhooks.
export const fetchOperatorOptions = async (variables: OperatorOptionsQueryVariables) => {
  const response = await queryExecute({
    variables,
    fetchPolicy: 'network-only',
    query: graphql(`
      query OperatorOptions($pagination: PaginationInputType, $query: String, $isActive: Boolean) {
        operators(pagination: $pagination, query: $query, isActive: $isActive) {
          count
          rows {
            id
            firstName
            lastName
          }
        }
      }
    `),
  });

  return response.data.operators;
};
